import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { IonicModule } from '@ionic/angular';
import { AppUpdateService } from '../../services/app-updates/app-update.service';
import { IconComponent } from '../../../shared/components/icon/icon.component';


@Component({
  selector: 'app-update-dialog',
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatButtonModule, MatIconModule, IonicModule, IconComponent],
  templateUrl: './update-dialog.component.html',
  styleUrl: './update-dialog.component.scss'
})
export class UpdateDialogComponent {
  private readonly dialogRef = inject(MatDialogRef<UpdateDialogComponent>);
  private readonly updateService = inject(AppUpdateService);
  readonly data = inject(MAT_DIALOG_DATA) as { 
    isRequired: boolean; 
    isStoreUpdate?: boolean;
    updateType?: string;
    platform?: string;
    customMessage?: string;
  };

  dismiss(): void {
    this.dialogRef.close('dismissed');
  }

  async updateNow(): Promise<void> {
    if (this.data.updateType === 'sideloaded') {
      // For sideloaded apps, open Play Store directly
      await (this.updateService as any).openPlayStore();
    } else {
      // For regular updates, use the normal update flow
      await this.updateService.updateNow();
    }
    this.dialogRef.close('updated');
  }
}
